import * as React from 'react';
export const dfcuSvg = React.forwardRef(function dfcuSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.767 14.032c.205.73.305 1.485.296 2.243h4.004l.663-2.252-4.963.01Zm-10.48-1.918a2.997 2.997 0 0 0 1.036 2.772c.954.783 2.586 1.232 3.713 2.024 1.126.792 1.737 1.909 1.493 3.111a4.132 4.132 0 0 1-2.82 2.902c-1.484.477-3.364.115-3.436.134a10.29 10.29 0 0 0 3.37.234 8.018 8.018 0 0 0 4.523-2 6.777 6.777 0 0 0 2.129-4.109 7.245 7.245 0 0 0-.869-4.558 6.876 6.876 0 0 0-3.145-2.7 5.965 5.965 0 0 0-2.954-.478 3.278 3.278 0 0 0-1.885.716 3.102 3.102 0 0 0-1.16 1.947l.005.005Z',
      fill: '#206590',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.885 9.594h2.605L6.61 23.147H4L7.885 9.594Z',
      fill: '#33C2F2',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.116 9.594c1.299.682 1.723 1.188 2.663 2.2h6.605l.616-2.2h-9.884Z',
      fill: '#206590',
    }),
  );
});
dfcuSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var dfcu = {
  category: 'brand',
  colorable: false,
  name: 'dfcu',
  svg: dfcuSvg,
};
